import axios from "axios";
export default {
    getStatistics() {
        return axios.get(`/statistics`);
    },
    getStatisticAmounts(){
        return axios.get(`/statistics/orders/amount`);
    },
    getStatisticCount(){
        return axios.get(`/statistics/orders/count`)
    },
    getStatisticDoing(){
        return axios.get(`/statistics/orders/doing`)
    },
    getStatisticTimeSpend(){
        return axios.get(`/statistics/orders/timespend`)
    }
};
